export default {
    header: {
        company: "Cuprolli Manufacturing srl",
        vatIdLabel: "CUI",
        vatId: "RO 35671874",
        regComLabel: "RegCom",
        regCom: "J2016000468359",
        addressLabel: "Adresa",
        address1: "Strada Caprioarei nr.11",
        address2: "307200 Ghiroda, jud.Timis",
        address3: "Romania",
        email: "office@i-struct.ro",
        webLabel: "Web",
        web1: "https://i-struct.ro",
        web2: "https://garduri-aluminiu.ro"
    },
    dateFormat: "DD.MM.YYYY",
    cifLabel: "CUI/CIF:",
    emailLabel: "Email",
    phoneLabel: "Tel",
    toLabel: "Catre",
    byLabel: "Intocmit de",
    noLabel: "Nr",
    offerTitle: "OFERTA DE PRET",
    quoteTitle: "DEVIZ",
    imgDisclaimer: "Poza are caracter exemplificativ",
    umLabels: {
        kg: 'kg',
        ml: 'ml',
        m2: 'm²',
        buc: 'buc.',
        h: 'ore',
        l: 'litri'
    },
    // What a module is called on the offer and in the PDF, keyed by type and variant.
    // framedPanel is a retired type kept for offers that still carry one.
    // Names as the client supplied them. framedPanel is a retired type kept for offers
    // that still carry one.
    moduleNames: {
        panel: "Panou",
        pedestrianGate: "Poartă pietonală",
        pedestrianGateSidePanel: "Poartă pietonală cu panou lateral",
        swingGateSingleLeaf: "Poartă auto batantă 1 canat",
        swingGateDoubleLeaf: "Poartă auto batantă 2 canate",
        swingGateBiFoldSingle: "Poartă auto batantă 1 canat bi-fold",
        swingGateBiFoldDouble: "Poartă auto batantă 2 canate bi-fold",
        slidingGateSingleLeaf: "Poartă auto culisantă 1 canat",
        slidingGateDoubleLeaf: "Poartă auto culisantă 2 canate",
        slidingGateTelescopic: "Poartă auto culisantă telescopică",
        slidingGateArticulated: "Poartă auto culisantă articulată",
        selfSupportingGate: "Poartă auto autoportantă",
        posts: "Stâlpi",
        post80: "Stâlp 80 × 80 mm",
        post100: "Stâlp 100 × 100 mm",
        post200: "Stâlp 200 × 100 mm",
        framedPanel: "Panou cu ramă"
    },
    moduleLabels: {
        piece: "buc.",
        dimensions: "Dimensiuni (l x h)",
        area: "Suprafata",
        slatWidth: "Latime lamela",
        noProfiles: "Nr. lamele",
        slatDistance: "Distanta intre lamele",
        slatOverlap: "Suprapunere lamele",
        slatDimension: "Dimensiune lamela",
        pedestrianGateWidth: "Latime poarta pietonala",
        height: "Inaltime",
        priceArea: "Pret / m²",
        priceLength: "Pret / ml",
        priceSingle: "Pret unitar",
        priceTotal: "Valoare totala"
    },
    totalsLabels: {
        currency: "euro",
        total: "TOTAL",
        vatIncluded: "TVA inclus",
        color: "CULOARE",
        montageIncluded: "MONTAJ INCLUS",
        montageNotIncluded: "FARA MONTAJ",
        measureMontageNotInluded: "FARA MASURATORI SI MONTAJ",
        price_no_VAT_msg: "Pretul este valabil pentru persoane juridice platitoare de TVA cu cod valid in VIES:",
        price_VAT_msg: "Pretul pentru persoane fizice sau firme neplatitoare de TVA:"
    },
    features: {
        featuresTitle: "CARACTERISTICI",
        projectsTitle: "PROIECTE REALIZATE",
        projectsLink: "https://garduri-aluminiu.ro/proiecte-realizate",
        list: ["- profile din aluminiu", "- vopsit in camp electrostatic", "- vopsea aplicata termic", "- prindere mecanica cu popnituri vopsite electrostatic", "- fara sudura"]
    },
    extraDetails: {
        title: "Detalii suplimentare",
        payment: "Conditii plata",
        upfrontPayment: "avans",
        extraPayment: "la masuratori",
        afterPayment: "dupa finalizarea montajului",
        execution: "Timp executie",
        days: "zile",
        years: "ani",
        warranty: "Garantie lucrare",
        validOffer: "Valabilitate oferta",
        montageDate: "Programare lucrare",
        finalDate: "Finalizare lucrare",
        paymentDisclaimer: "* Valoarea finala a facturii va fi calculata in lei la cursul de schimb al Bancii Transilvania din data facturarii."
    },
    nextPage: "Continuare pe pagina urmatoare"
}